// import React from 'react';
// import { motion } from 'framer-motion';
// import Footer from '../../../components/Footer';
// import {
//     GraduationCap,
//     Stars,
//     Clock,
//     Bookmark,
//     ArrowUpRight,
//     Users,
//     BookOpen,
//     Award,
//     Globe,
//     Rocket,
//     FlaskConical,
//     Microscope,
//     Atom,
//     Leaf
// } from 'lucide-react';
// import { Link } from 'react-router-dom';
// import ScienceImg from "../../../assets/images/science.jpeg";
// import Title from '../../../components/TitleComponent';

// const bscCourses = [
//     { name: "B.SC CBZ/B.SC CBZ HONS", path: "bsc/chemistry-botany-zoology" },
//     { name: "B.Sc. (PCM) / Hons. B.Sc – Hons.", path: "bsc/physics-chemistry-maths" },
//     { name: "B.Sc. Environmental Sciences / Hons.", path: "bsc/environmental-science" }
// ];

// const mscCourses = [
//     { name: "M.Sc. in Physics", path: "msc/physics" },
//     { name: "M.Sc. in Chemistry", path: "msc/chemistry" },
//     { name: "M.Sc. in Mathematics", path: "msc/mathematics" },
//     { name: "M.Sc. in Zoology", path: "msc/zoology" },
//     { name: "M.Sc. in Botany", path: "msc/botany" },
//     { name: "M.Sc. in Environmental Sciences", path: "msc/environmental-science" }
// ];

// const Stats = () => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-4 md:my-8 px-4"
//     >
//         {[
//             { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "1500+", label: "Students Enrolled", color: "bg-blue-50" },
//             { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "9+", label: "Programs Offered", color: "bg-green-50" },
//             { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "90%", label: "Research Success Rate", color: "bg-purple-50" },
//             { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "40+", label: "Research Projects", color: "bg-orange-50" }
//         ].map((stat, index) => (
//             <motion.div
//                 key={index}
//                 className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
//                 whileHover={{ scale: 1.02 }}
//             >
//                 <div className="text-[#0e4d38]">{stat.icon}</div>
//                 <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
//                 <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
//             </motion.div>
//         ))}
//     </motion.div>
// );

// const CourseCard = ({ course, index }) => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         transition={{ delay: index * 0.1 }}
//         className="group w-full"
//     >
//         <Link to={course.path}>
//             <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
//                 <div>
//                     <div className="flex justify-between items-start">
//                         <div className="p-2 bg-blue-50 rounded-lg">
//                             <Atom className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
//                         </div>
//                         <motion.div
//                             whileHover={{ scale: 1.1 }}
//                             className="p-1 md:p-2 rounded-full hover:bg-gray-100"
//                         >
//                             <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
//                         </motion.div>
//                     </div>
//                     <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
//                         {course.name}
//                     </h3>
//                 </div>
//                 <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
//                     <div className="flex items-center gap-1">
//                         <Clock className="w-3 h-3" />
//                         <span>{course.name.includes('M.Sc') ? '2 Years' : '3/4 Years'}</span>
//                     </div>
//                     <div className="flex items-center gap-1">
//                         <Bookmark className="w-3 h-3" />
//                         <span>{course.name.includes('M.Sc') ? 'PG' : 'UG'}</span>
//                     </div>
//                 </div>
//             </div>
//         </Link>
//     </motion.div>
// );

// const Department = ({ title, icon, courses }) => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
//     >
//         <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
//             <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
//                 {icon}
//             </div>
//             <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
//             {courses.map((course, index) => (
//                 <CourseCard key={index} course={course} index={index} />
//             ))}
//         </div>

//     </motion.div>
// );

// const FeatureList = ({ title, items, icon }) => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
//     >
//         <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
//             <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
//                 {icon}
//             </div>
//             <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
//             {items.map((item, index) => (
//                 <motion.div
//                     key={index}
//                     className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
//                     whileHover={{ scale: 1.02 }}
//                 >
//                     <div className="flex items-start gap-2">
//                         <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
//                         <span className="text-gray-700 text-xs md:text-sm">{item}</span>
//                     </div>
//                 </motion.div>
//             ))}
//         </div>

//     </motion.div>
// );

// const HeroSection = () => (
//     <div className="relative overflow-hidden bg-[#0e4d38] text-white py-8 md:py-16 px-4 md:px-6 rounded-xl mb-6 md:mb-8 mt-16 md:mt-20">
//         <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="max-w-5xl"
//         >
//             <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4">
//                 School of Applied Sciences
//             </h1>
//             <p className="text-sm md:text-lg text-gray-200 mb-4 md:mb-6 max-w-3xl">
//                 Empowering future scientists with comprehensive education and research opportunities.
//                 Join us in exploring the frontiers of science and innovation.
//             </p>
//             <Link to="https://admission.maya.edu.in/">
//                 <motion.button
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                     className="bg-white text-[#0e4d38] px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-semibold flex items-center gap-2 group"
//                 >
//                     Apply Now
//                     <Rocket className="w-3 h-3 md:w-4 md:h-4 group-hover:translate-x-1 transition-transform" />
//                 </motion.button>
//             </Link>
//         </motion.div>
//     </div>
// );

// const Science = () => {
//     return (
//         <div className="min-h-screen bg-gray-50 font-poppins">
//             <Title canonicalPath="/programmes/ug-courses/sciences" />
//             <Title title="School of Applied Sciences at Maya Devi University" description="Explore the School of Applied Sciences at MDU, Dehradun. Gain practical knowledge and skills for a successful career in science and technology." />
//             <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
//                 <HeroSection />
//                 <Stats />

//                 <div className="space-y-6 md:space-y-8">
//                     <Department
//                         title="Bachelor of Science Programs"
//                         icon={<GraduationCap className="w-5 h-5 md:w-6 md:h-6" />}
//                         courses={bscCourses}
//                     />
//                     {/* <Department
//                         title="Master of Science Programs"
//                         icon={<Microscope className="w-5 h-5 md:w-6 md:h-6" />}
//                         courses={mscCourses}
//                     /> */}
//                     <p className="text-red-600 font-semibold text-center">
//                         *For BSc Hons, duration of MSc will be 1 year*
//                     </p>
//                 </div>


//                 <div className="space-y-6 md:space-y-8">
//                     <FeatureList
//                         title="USPs"
//                         icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
//                         items={[
//                             "State-of-the-Art Research Facilities",
//                             "Experienced Faculty with Research Background",
//                             "Industry-Academia Collaborations",
//                             "Choice Based Credit System (CBCS)",
//                             "Research-Oriented Curriculum",
//                             "Modern Laboratory Infrastructure",
//                             "International Research Exposure",
//                             "Project-Based Learning",
//                             "Scientific Paper Publications",
//                             "Research Funding Opportunities",
//                             "Interdisciplinary Approach",
//                             "Industry-Relevant Training"
//                         ]}
//                     />

//                     <FeatureList
//                         title="Career Options"
//                         icon={<FlaskConical className="w-6 h-6 text-[#0e4d38]" />}
//                         items={[
//                             "Research Scientist",
//                             "Data Analyst",
//                             "Environmental Consultant",
//                             "Laboratory Manager",
//                             "Quality Control Specialist",
//                             "Science Educator",
//                             "R&D Professional",
//                             "Technical Writer",
//                             "Patent Analyst",
//                             "Environmental Officer",
//                             "Scientific Researcher",
//                             "Product Development Scientist"
//                         ]}
//                     />
//                 </div>
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default Science;





import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../../../components/Footer';
import {
    GraduationCap,
    Stars,
    Clock,
    Bookmark,
    ArrowUpRight,
    Users,
    BookOpen,
    Award,
    Globe,
    Rocket,
    BookType,
    FlaskConical,
    Microscope,
    Stethoscope,
    FileText,
    Download,
    User,
    FileDigit,
    ShieldCheck,
    Users2,
    FileCheck,
    School,
    ArrowRight,
    Beaker,
    Trophy, Atom, Zap, Shield, LucideSearch, Activity, CheckCircle,
} from 'lucide-react';
import { Link } from 'react-router-dom';

import Title from '../../../components/TitleComponent';
import Dean from "../../../assets/schools/applied_science/dean.webp";
import overview from "../../../assets/schools/applied_science/overview.webp";
import Why from "../../../assets/schools/applied_science/why.webp";
import {
    TbPlant2,
    TbWorldWww,
    TbSchool,
    TbFlask,
    TbUsers,
    TbBriefcase,
    TbLeaf,
    TbTrophy,
    TbAward,
    TbQuote,

} from "react-icons/tb";
import { Target, Eye } from "lucide-react";
import { useState } from "react";





import Arpit from '../../../assets/schools/applied_science/placements/Arpit.png';
import Asha from '../../../assets/schools/applied_science/placements/Asha.png';
import Bhanu from '../../../assets/schools/applied_science/placements/BHanu.png';
import Khusboo from '../../../assets/schools/applied_science/placements/Khusboo.png';
import Shubham from '../../../assets/schools/applied_science/placements/Shubham.png';
import Soumik from '../../../assets/schools/applied_science/placements/Soumik.png';
import Suhail from '../../../assets/schools/applied_science/placements/Suhail.png';
import Tushar from '../../../assets/schools/applied_science/placements/Tushar.png';

import Khushi from '../../../assets/schools/applied_science/students/Khushi.jpg';
import Manisha from '../../../assets/schools/applied_science/students/Manisha.jpg';
import Rahul from '../../../assets/schools/applied_science/students/Rahul.jpg';
import Riya from '../../../assets/schools/applied_science/students/Riya.jpg';


import ScienceLogoSlider from '../../../components/ScienceLogoSlider';

const pharmacyCourses = {
    Diploma: [
        { name: "Diploma in Pharmacy (D.Pharm)", path: "best-d-pharma-college-in-dehradun-uttarakhand" },
    ],
    undergraduate: [
        { name: "B.Sc. PCM", path: "bsc-pcm-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. CBZ", path: "bsc-cbz-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Botany", path: "bsc-botany-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Zoology", path: "bsc-zoology-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Chemistry", path: "bsc-chemistry-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Physics", path: "bsc-physics-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Mathematics", path: "bsc-mathematics-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Environmental Science", path: "bsc-environmental-science-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Forensic Science", path: "bsc-forensic-science-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Microbiology", path: "bsc-microbiology-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Biotechnology", path: "bsc-biotechnology-colleges-in-dehradun-uttarakhand" },

        { name: "B.Sc. Botany (Hons.)", path: "bsc-botany-hons-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Chemistry (Hons.)", path: "bsc-chemistry-hons-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Physics (Hons.)", path: "bsc-physics-hons-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Mathematics (Hons.)", path: "bsc-mathematics-hons-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Environmental Science (Hons.)", path: "bsc-environmental-science-hons-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Forensic Science (Hons.)", path: "bsc-forensic-science-hons-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Microbiology (Hons.)", path: "bsc-microbiology-hons-colleges-in-dehradun-uttarakhand" },
        { name: "B.Sc. Biotechnology (Hons.)", path: "bsc-biotechnology-hons-colleges-in-dehradun-uttarakhand" }
    ],
    postgraduate: [
        { name: "M.Sc. Botany", path: "/programmes/pg-courses/science/msc-botany" },
        { name: "M.Sc. Zoology", path: "/programmes/pg-courses/science/msc-zoology" },
        { name: "M.Sc. Chemistry", path: "/programmes/pg-courses/science/msc-chemistry" },
        { name: "M.Sc. Physics", path: "/programmes/pg-courses/science/msc-physics" },
        { name: "M.Sc. Mathematics", path: "/programmes/pg-courses/science/msc-mathematics" },
        { name: "M.Sc. Environmental Science", path: "/programmes/pg-courses/science/msc-environmental-science" },
        { name: "M.Sc. Forensic Science", path: "/programmes/pg-courses/science/msc-forensic-science" },
        { name: "M.Sc. Microbiology", path: "/programmes/pg-courses/science/msc-microbiology" },
        { name: "M.Sc. Biotechnology", path: "/programmes/pg-courses/science/msc-biotechnology" }
    ],
    doctorate: [
        { name: "Pharm D (Doctor of Pharmacy)", path: "/programmes/phd-courses/pharmacy/DoctorPharmacy" }
    ]
};

// PDF Resources
// const pdfResources = [
//     {
//         title: "Regulatory Approvals",
//         icon: <ShieldCheck className="w-5 h-5 md:w-6 md:h-6" />,
//         documents: [
//             {
//                 name: "PCI Approval 2023-24",
//                 description: "Pharmacy Council of India Official Approval Document",
//                 path: pci, // Use the imported file directly
//                 icon: <FileCheck className="w-4 h-4" />
//             }
//         ]
//     },
//     {
//         title: "Academic Results",
//         icon: <FileDigit className="w-5 h-5 md:w-6 md:h-6" />,
//         documents: [
//             {
//                 name: "B. Pharma Results 2024",
//                 description: "Official examination results for B.Pharma",
//                 path: Result,
//                 icon: <School className="w-4 h-4" />
//             },
//             // {
//             //     name: "B.Pharma 1st Semester Results 2024 (Math Result)",
//             //     description: "Official examination results for B.Pharma first semester",
//             //     path: mathresult,
//             //     icon: <School className="w-4 h-4" />
//             // }
//         ]
//     },
//     {
//         title: "Institutional Committees",
//         icon: <Users2 className="w-5 h-5 md:w-6 md:h-6" />,
//         documents: [
//             {
//                 name: "Anti-Ragging Committee",
//                 description: "Members and guidelines of the Anti-Ragging Committee",
//                 path: Antiraging,
//                 icon: <ShieldCheck className="w-4 h-4" />
//             },
//             {
//                 name: "Gender Sensitization Committee",
//                 description: "Members and guidelines of the Gender Sensitization Committee",
//                 path: GenderSensitizationCommittee,
//                 icon: <Users2 className="w-4 h-4" />
//             }
//         ]
//     },
//     {
//         title: "Student Information",
//         icon: <User className="w-5 h-5 md:w-6 md:h-6" />,
//         documents: [
//             {
//                 name: "Category-wise List of B.Pharma Students 2024",
//                 description: "Complete list of enrolled students with category classification",
//                 path: bpharmastudents,
//                 icon: <Users className="w-4 h-4" />
//             },
//             {
//                 name: "Category-wise List of D.Pharma Students 2024",
//                 description: "Complete list of enrolled students with category classification",
//                 path: Dpharmastudents,
//                 icon: <Users className="w-4 h-4" />
//             }
//         ]
//     }
// ];


// const achievements = [
//     {
//         name: "Aayushman Rauniyar",
//         achievement: "Chess(Men)",
//         images: {
//             profile: AayushmanAward,
//             certificate: AayushmanCertificate,
//             award: AayushmanAward
//         }
//     },
//     {
//         name: "Danish",
//         achievement: "Selected in National Floorball championship",
//         images: {
//             profile: Danish,
//             certificate: DanishCertificate,
//             award: Danish1
//         }
//     }
// ];


const AboutSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-8 rounded-xl shadow-lg mb-12"
    >
        {/* Overview section with image - side by side on web, stacked on mobile */}
        <div className="flex flex-col lg:flex-row gap-8 items-center mb-10">
            <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                        <BookOpen className="w-6 h-6" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Overview</h2>
                </div>
                <div className="space-y-4 text-gray-700 text-lg">
                    <p>The School of Life and Applied Sciences at Maya Devi University, Dehradun, is committed to advancing scientific education and research through its well-structured undergraduate, postgraduate, and doctoral programs. It offers B.Sc. and M.Sc. programs. The school also provides opportunities for Ph.D. research in various branches of applied sciences. With a team of highly qualified and experienced faculty, the school emphasizes both theoretical knowledge and practical skills through laboratory-based learning and project work. Students benefit from modern infrastructure, including well-equipped labs, digital resources, and a rich academic environment. The school encourages innovation, interdisciplinary learning, and career readiness, supported by an active placement cell. Through academic rigor, research initiatives, and industry engagement, the School of Applied Sciences plays a vital role in preparing students for impactful careers in science and technology. </p>
                </div>
            </div>
            <div className="w-full lg:w-1/2 relative h-80 md:h-96 rounded-xl overflow-hidden shadow-xl">
                <img
                    src={overview}
                    alt="School of Life and Applied Sciences "
                    className="w-full h-full object-cover rounded-xl transition-transform duration-700 hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0e4d38]/70 to-transparent flex items-end">
                    <div className="p-6">
                        <h3 className="text-white text-xl font-bold">Cutting-edge Learning Environment</h3>
                        <p className="text-white/80 text-sm">Modern classrooms and advanced labs</p>
                    </div>
                </div>
            </div>
        </div>

        {/* Mission section - full width on web, normal on mobile */}
        <div className="w-full mb-10">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Target className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Mission</h2>
            </div>
            <div className="text-gray-700 text-lg">
                <p>The school’s mission is to impart high-quality education, foster scientific curiosity, and contribute to advancements in research and its applications in industry, health, and the environment. </p>
            </div>
        </div>

        {/* Vision section - full width on web, normal on mobile */}
        <div className="w-full">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Eye className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Vision</h2>
            </div>
            <div className="text-gray-700 text-lg">
                <p>The vision of applied sciences is to utilize scientific knowledge and methods to address real-world problems and create practical solutions. This includes developing new technologies, solving challenges, and improving various aspects of society, such as healthcare and environmental protection. Applied science aims to bridge the gap between theoretical scientific understanding and its practical application, ultimately leading to advancements and innovations. </p>
            </div>
        </div>
    </motion.div>
);


const Stats = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 my-3 md:my-8 px-4"
    >
        {[
            // { icon: <Users className="w-6 h-6 md:w-8 md:h-8" />, number: "1000+", label: "Students Enrolled", color: "bg-blue-50" },
            { icon: <BookOpen className="w-6 h-6 md:w-8 md:h-8" />, number: "29", label: "Programs Offered", color: "bg-green-50" },
            { icon: <Award className="w-6 h-6 md:w-8 md:h-8" />, number: "48 LPA", label: "Heighest Package", color: "bg-purple-50" },
            { icon: <Globe className="w-6 h-6 md:w-8 md:h-8" />, number: "100+", label: "Total Number of Students Placed", color: "bg-orange-50" }
        ].map((stat, index) => (
            <motion.div
                key={index}
                className={`${stat.color} p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300`}
                whileHover={{ scale: 1.02 }}
            >
                <div className="text-[#0e4d38]">{stat.icon}</div>
                <h3 className="text-xl md:text-2xl font-bold mt-2 text-gray-800">{stat.number}</h3>
                <p className="text-gray-600 text-xs md:text-sm">{stat.label}</p>
            </motion.div>
        ))}
    </motion.div>
);

const TestimonialCard = ({ student, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.2 }}
        className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full"
    >
        <div className="bg-gradient-to-r from-[#0e4d38]/10 to-[#23376c]/10 p-4">
            <div className="flex items-center gap-3">
                <div className="w-14 h-14 rounded-full bg-gray-200 overflow-hidden">
                    <img
                        src={student.image}
                        alt={student.name}
                        className="w-full h-full object-cover"
                    />
                </div>
                <div>
                    <h3 className="font-bold text-lg text-gray-800">{student.name}</h3>
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                        <Building className="w-3 h-3" />
                        <span>{student.company}</span>
                    </div>
                </div>
            </div>
        </div>

        <div className="p-6 flex-1 flex flex-col">
            <div className="text-[#0e4d38] mb-3">
                <MessageSquareQuote className="w-6 h-6" />
            </div>
            <p className="text-gray-700 italic flex-1">{student.testimonial}</p>

            <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                {student.award && (
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                        <Award className="w-4 h-4 text-[#0e4d38]" />
                        <span>{student.role}</span>
                    </div>
                )}
                {/* <div className="text-sm text-gray-500">Class of {student.graduationYear}</div> */}
            </div>
        </div>
    </motion.div>
);

const StudentTestimonials = () => {
    const testimonials = [
        {
            name: "Kritika Verma",
            role: "B.Sc. II Semester CBZ ",
            quote: "Maya Devi University is a peaceful and modern place to study. The campus offers a green and quiet environment perfect for learning. The university has smart classrooms, well-equipped labs, a large library, and comfortable hostels. The teachers at MDU are highly qualified, and experienced. They are friendly, supportive, and always ready to help students understand their subjects better. The department also focuses on practical learning and help student gain real world experiences. Students can join technical clubs, participate in music and dance groups, or engage in sports such as basketball, cricket, and badminton. Here, students enjoy a lively campus life with cultural events, sports, and clubs that help them grow personally and professionally. With its quality education and student development, it's a great place to build a bright future. ",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Khushi Verma",
            role: "B.Sc. II Semester PCM ",
            quote: "Maya Devi University offers a green campus with a variety of courses in different streams. Among them, the B.Sc. program stands out for its updated syllabus and focus on practical learning. The B.Sc. department is well-managed, with experienced faculty, regular lab sessions, and strong support for students. The university provides modern labs, a rich library, and smart classrooms to enhance education. Teachers are qualified and always ready to guide, while the management is student-friendly and focused on continuous improvement. With quality teaching, good facilities, and a supportive environment, it’s a great place for learning and growth. ",
            image: Khushi
        },
        {
            name: "Shalini ",
            role: "B.Pharm Graduate",
            quote: "I am a student of B.Sc. The department has a friendly and helpful atmosphere for learning. Faculty members are experienced, knowledgeable and always willing to guide students whether it's during lectures, practical or even outside class hours.  The laboratories are well-equipped and organized which makes learning much easier. The department also encourages participation in academic activities like workshops, seminars and science exhibitions which enhance both knowledge and skills. Classes are easy to follow and doubts are cleared properly. Assignments, practical files and internal exams are taken seriously so it's easier to stay on track with the syllabus. Overall it's been a good experience and a nice place to study and grow in a supportive environment.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Manisha",
            role: "M.Sc. Chemistry (2 Sem) ",
            quote: "The coursework has been engaging and challenging, with a focus on applying theoretical concepts to realworld problems. I have developed a deeper understanding of chemical principles and their practical applications. ",
            image: Manisha
        },
        {
            name: "Riya Gupta",
            role: "M.Sc. Chemistry (2 Sem) ",
            quote: "As a student in the chemistry department, I have had the opportunity to explore the fascinating world of chemical reactions and processes. The department's well-equipped labs have allowed me to gain hands-on experience with modern instruments and techniques. ",
            image: Riya
        },
        {
            name: "Rahul ",
            role: "M.Sc. Chemistry (2 Sem) ",
            quote: "I have been impressed by the department's resources and facilities. The library and online databases provide access to a wealth of information. The collaborative environment among students fosters a sense of community and teamwork. ",
            image: Rahul
        },

    ];

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white p-8 rounded-xl shadow-lg mb-12"
        >
            <div className="flex items-center gap-3 mb-8">
                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                    <Users className="w-6 h-6" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Student Testimonials</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {testimonials.map((testimonial, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.2 }}
                        className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-full hover:shadow-lg transition-all duration-300"
                    >
                        <div className="bg-gradient-to-r from-[#0e4d38]/10 to-[#23376c]/10 p-4">
                            <div className="flex items-center gap-3">
                                <div className="w-14 h-14 rounded-full overflow-hidden">
                                    <img
                                        src={testimonial.image}
                                        alt={testimonial.name}
                                        className="w-full h-full object-cover"
                                        loading="lazy"
                                    />
                                </div>
                                <div>
                                    <h3 className="font-bold text-lg text-gray-800">{testimonial.name}</h3>
                                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                                </div>
                            </div>
                        </div>

                        <div className="p-6 flex-1 flex flex-col">
                            <div className="text-[#0e4d38] mb-3">
                                <TbQuote size={24} />
                            </div>
                            <p className="text-gray-700 italic flex-1">{testimonial.quote}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </motion.div>
    );
};

const CourseCard = ({ course, index }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: index * 0.1 }}
        className="group w-full"
    >
        <Link to={course.path}>
            <div className="bg-white p-3 md:p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col justify-between gap-2 md:gap-3">
                <div>
                    <div className="flex justify-between items-start">
                        <div className="p-2 bg-blue-50 rounded-lg">
                            {course.name.toLowerCase().includes('pharm d') ? (
                                <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            ) : course.name.toLowerCase().includes('m.pharm') ? (
                                <BookType className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            ) : (
                                <FlaskConical className="w-4 h-4 md:w-5 md:h-5 text-blue-600" />
                            )}
                        </div>
                        <motion.div
                            whileHover={{ scale: 1.1 }}
                            className="p-1 md:p-2 rounded-full hover:bg-gray-100"
                        >
                            <ArrowUpRight className="w-3 h-3 md:w-4 md:h-4 text-gray-400 group-hover:text-[#0e4d38]" />
                        </motion.div>
                    </div>
                    <h3 className="text-sm md:text-lg font-semibold mt-2 md:mt-3 text-gray-800 group-hover:text-[#0e4d38] transition-colors line-clamp-2">
                        {course.name}
                    </h3>
                </div>
                <div className="flex items-center gap-2 md:gap-3 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                        <Clock className="w-3 h-3" />
                        <span>
                            {course.name.includes('D.Pharm') ? '2 Years' :
                                course.name.includes('B.Pharm - LE') ? '3 Years' :
                                    course.name.includes('B.Pharm') ? '4 Years' :
                                        course.name.includes('M.Pharm') ? '2 Years' :
                                            course.name.includes('Pharm D') ? '6 Years' : 'Duration'}
                        </span>
                    </div>
                    <div className="flex items-center gap-1">
                        <Bookmark className="w-3 h-3" />
                        <span>
                            {course.name.includes('M.Pharm') ? 'PG' :
                                course.name.includes('Pharm D') ? 'Doctor' : 'UG'}
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    </motion.div>
);

const Department = ({ title, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>

        {/* Diploma Programs */}
        {/* <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Diploma Program</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.Diploma.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div> */}
        {/* Undergraduate Programs */}
        <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Undergraduate Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.undergraduate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div>

        {/* Postgraduate Programs */}
        <div className="mb-8">
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Postgraduate Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.postgraduate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div>

        {/* Doctorate Programs */}
        {/* <div>
            <h5 className="text-lg font-semibold text-gray-800 mb-4">Doctor Programs</h5>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {pharmacyCourses.doctorate.map((course, index) => (
                    <CourseCard key={index} course={course} index={index} />
                ))}
            </div>
        </div> */}
    </motion.div>
);

const FeatureList = ({ title, items, icon }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-xl text-white">
                {icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
            {items.map((item, index) => (
                <motion.div
                    key={index}
                    className="p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
                    whileHover={{ scale: 1.02 }}
                >
                    <div className="flex items-start gap-2">
                        <div className="w-2 h-2 mt-1.5 bg-[#23376c] rounded-full flex-shrink-0" />
                        <span className="text-gray-700 text-xs md:text-sm">{item}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </motion.div>
);

const HeroSection = () => (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#0e4d38] to-[#23376c] text-white py-12 md:py-20 px-6 md:px-10 rounded-xl mb-8 md:mb-12">
        <div className="absolute inset-0 bg-[url('/api/placeholder/1600/800')] bg-cover bg-center opacity-10 mix-blend-overlay" aria-hidden="true"></div>
        <div className="absolute -right-20 -bottom-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>
        <div className="absolute -left-20 -top-20 w-64 h-64 bg-white opacity-10 rounded-full blur-3xl" aria-hidden="true"></div>

        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-6xl mx-auto relative z-10"
        >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">
                School of Life and Applied Sciences
            </h1>
            <h2 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8 text-green-100">
                Shaping Tomorrow's Leaders at Maya Devi University
            </h2>

            <div className="flex flex-wrap gap-4 md:gap-6">
                <Link to="https://admission.maya.edu.in/">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-white text-[#0e4d38] px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group shadow-lg"
                    >
                        Apply Now
                        <Rocket className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </motion.button>
                </Link>
                {/* <Link to="#programs">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-transparent border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold flex items-center gap-2 group"
                    >
                        Explore Programs
                        <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
                    </motion.button>
                </Link> */}
            </div>
        </motion.div>
    </div>
);

// Dean Section Component
const DeanSection = () => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg overflow-hidden"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                <GraduationCap className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">From the Dean's Desk</h4>
        </div>

        <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center">
            <div className="w-full md:w-1/3 lg:w-1/4 flex flex-col items-center">
                <motion.div
                    whileHover={{ scale: 1.02 }}
                    className="rounded-xl overflow-hidden max-w-[250px]"
                >
                    <img
                        src={Dean}
                        alt="Prof. (Dr.) Shivani Guleria "
                        className="w-[250px] h-[250px] object-contain bg-white rounded-xl shadow-lg"
                    />
                </motion.div>
                <div className="text-center mt-3">
                    <h5 className="font-bold text-lg text-gray-800">Prof. (Dr.) Shivani Guleria </h5>
                    <p className="text-sm text-gray-600">Dean, School of Life and Applied Sciences</p>
                </div>
            </div>

            <div className="w-full md:w-2/3 lg:w-3/4 flex flex-col justify-center h-full">
                <p className="text-gray-700 text-sm md:text-base mb-4">
                    It is with great pride and enthusiasm that I welcome you to the School of Life and Applied Sciences at Maya Devi University comprising the departments of Physics, Chemistry, Mathematics, Botany, and Zoology. Our school is a dynamic center for scientific learning and innovation.
                </p>
                <p className="text-gray-700 text-sm md:text-base mb-4">
                    We are committed for delivering a strong academic foundation through well-structured undergraduate and postgraduate programs that integrate theoretical concepts with hands-on practical experience. Our dedicated faculties foster a culture of inquiry, encouraging students to explore beyond the classroom and engage in research, innovation, and interdisciplinary collaboration.
                </p>
                <p className="text-gray-700 text-sm md:text-base">
                    At the School of Applied Sciences, we prepare students not just for examinations, but for real-world challenges—equipping them with the skills, knowledge, and values needed to thrive in academia, research, and industry at both national and global levels.
                </p>
                <p className="text-gray-700 text-sm md:text-base">
                    Join us to be part of a progressive scientific community that is shaping the future through education, exploration, and excellence.
                </p>
            </div>
        </div>
    </motion.div>
);


// const StudentAchievements = () => {
//     return (
//         <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
//             <div className="container mx-auto px-4">
//                 <h2 className="text-4xl font-extrabold text-center mb-4 text-indigo-900 tracking-tight">
//                     Student Achievements
//                 </h2>
//                 <p className="text-xl text-center text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed">
//                     Celebrating the remarkable achievements of our students
//                 </p>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//                     {achievements.map((student, index) => (
//                         <div
//                             key={index}
//                             className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300"
//                         >
//                             <div className="relative">
//                                 <img
//                                     src={student.images.profile}
//                                     alt={`${student.name} profile`}
//                                     className="w-full h-64 object-cover"
//                                 />
//                             </div>
//                             <div className="p-6">
//                                 <h3 className="text-2xl font-bold text-gray-800 mb-2">{student.name}</h3>
//                                 <p className="text-gray-700 bg-indigo-50 p-3 rounded-lg mb-4">
//                                     <span className="font-semibold">Achievement:</span> {student.achievement}
//                                 </p>
//                                 <div className="grid grid-cols-2 gap-4">
//                                     <img
//                                         src={student.images.certificate}
//                                         alt={`${student.name} certificate`}
//                                         className="w-full h-full object-cover rounded-lg shadow-sm"
//                                     />
//                                     <img
//                                         src={student.images.award}
//                                         alt={`${student.name} award`}
//                                         className="w-[200px] h-[250px] object-cover rounded-lg shadow-sm"
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     );
// };



const PharmacyDepartment = () => {
    // Data for Global Opportunities
    const globalOpportunities = [
        {
            title: "Licensing Exams",
            items: [
                "FPGEE (Foreign Pharmacy Graduate Equivalency Exam)",
                "GPhC Registration Exam (UK)",
                "NAPLEX (USA)",
                "PEBC (Canada)"
            ]
        },
        {
            title: "Higher Education",
            items: [
                "Postgraduate Programs Abroad",
                "Research Fellowships",
                "Ph.D. Opportunities"
            ]
        },
        {
            title: "Certifications",
            items: [
                "Clinical Pharmacy Certification (FCCP)",
                "Pharmaceutical Sciences Certifications",
                "Regulatory Affairs Certifications"
            ]
        }
    ];

    // Placements Data
    const placements = [
        { name: "Arpit", company: "Cipla Pharmaceuticals", position: "Assistant Manager", ctc: "5.5 LPA", image: Arpit },
        { name: "Asha", company: "East African Overseas", position: "Senior Officer", ctc: "3.3 LPA", image: Asha },
        { name: "Kuldeep Kumar", company: "Mankind Pharma", position: "Business Executive", ctc: "5 LPA", image: Bhanu },
        { name: "Ravi Kumar", company: "NKG Advisory", position: "Officer", ctc: "1.8 LPA", image: Khusboo },
        { name: "Suhail Bashir Khan", company: "Govt District Hospital", position: "Pharmacist", ctc: "4.80 LPA", image: Suhail },
        { name: "Jeewan Chandra Joshi", company: "Zee Lab Ltd", position: "Sr Executive", ctc: "6.90 LPA", image: Shubham },
        { name: "Aastha Shrivastava", company: "International Modern Hospital Dubai", position: "Pharmacist", ctc: "15 LPA", image: Soumik },
        { name: "Aastha Shrivastava", company: "International Modern Hospital Dubai", position: "Pharmacist", ctc: "15 LPA", image: Tushar }
    ];



    // Patents Data
    const patents = [
        "Dissolution Testing Apparatus To Simulate Colonic BioEnvironment",
        "Portable Electro Spinning Device For Development Of Nanofibres",
        "T-Maze Apparatus For Detection Of Locomotor Activity",
        "Variable Speed Rotating Drum",
        "Oil Filled Coverslip For Microscope",
        "Gas Chromatography Mass Spectrometer Apparatus",
        "Modified Silverson Mixer Emulsifier For Nanoparticle Synthesis"
    ];

    // Clubs Data
    const clubs = [
        {
            name: "Sports Clubs",
            icon: <TbTrophy size={24} />,
            description: "Promotes physical fitness, teamwork, and healthy competition through various sports activities."
        },
        {
            name: "Academic Clubs",
            icon: <TbUsers size={24} />,
            description: "Celebrates creativity through workshops, exhibitions, and cultural festivals."
        },
        {
            name: "Cultural Clubs",
            icon: <TbBriefcase size={24} />,
            description: "Bridges clinical knowledge with management skills for future healthcare leaders."
        },
        {
            name: "Career Exploration",
            icon: <TbLeaf size={24} />,
            description: "Promotes environmental awareness through sustainability initiatives."
        },
        {
            name: "Hobby Clubs",
            icon: <TbUsers size={24} />,
            description: "Advocates for gender equality and women's professional growth."
        }
    ];
    const societies = [
        {
            name: "Indian Chemical Society ",
            icon: <TbTrophy size={24} />,
            description: "Promotes physical fitness, teamwork, and healthy competition through various sports activities."
        },
        {
            name: "Institute of Chemistry of Ireland ",
            icon: <TbUsers size={24} />,
            description: "Celebrates creativity through workshops, exhibitions, and cultural festivals."
        },
        {
            name: "American Chemical Society ",
            icon: <TbBriefcase size={24} />,
            description: "Bridges clinical knowledge with management skills for future healthcare leaders."
        },
        // {
        //     name: "Career Exploration",
        //     icon: <TbLeaf size={24} />,
        //     description: "Promotes environmental awareness through sustainability initiatives."
        // },
        // {
        //     name: "Hobby Clubs",
        //     icon: <TbUsers size={24} />,
        //     description: "Advocates for gender equality and women's professional growth."
        // }
    ];

    // Testimonials Data
    const testimonials = [
        {
            name: "Rashmi Sharma",
            role: "Senior Officer, East African Overseas",
            quote: "It's hard to put into words what this college has given me — knowledge, confidence, friendships, and memories that will last a lifetime.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Kuldeep Kumar",
            role: "Business Executive, Mankind Pharma",
            quote: "The faculty was supportive, the campus environment inspiring, and the opportunities for growth were endless.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Abhinav Rawat",
            role: "B.Pharm Graduate",
            quote: "The supportive environment and excellent facilities make Maya Devi University a great choice for aspiring pharmacists.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Mahak",
            role: "B.Pharm Student",
            quote: "Our faculty members are extremely supportive and always willing to guide us through challenging topics.",
            image: "apis/images/placeholder.png"
        },
        {
            name: "Analisha Debbarma",
            role: "B.Pharm Student",
            quote: "I'm proud to be part of a place that values diversity and supports students from all backgrounds.",
            image: "/api/placeholder/300/300"
        }
    ];

    // State for active testimonial
    const [activeTestimonial, setActiveTestimonial] = useState(0);
    const [showCertificate, setShowCertificate] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);


    // const patents = [
    //     "Novel Drug Delivery System",
    //     "Sustained Release Formulation",
    //     "Targeted Therapy Mechanism",
    //     "Bioavailability Enhancement",
    //     "Anti-inflammatory Compound",
    //     "Nanoparticle Drug Carrier"
    //   ];

    // Separate certificate images
    // const certificateImages = [
    //     patent1,
    //     patent2,
    //     patent3,
    //     patent4
    // ];

    // Add this component before the PharmacyDepartment component

    const InfiniteSlider = ({ placements }) => {
        return (
            <div className="relative">
                {/* Mobile View - Grid Layout */}
                <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {placements.map((student, index) => (
                        <div
                            key={`mobile-${index}`}
                            className="w-full h-full flex justify-center items-center"
                        >
                            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
                                <div className="relative overflow-hidden h-72 w-full">
                                    <img
                                        src={student.image}
                                        alt={`${student.name || 'Graduate'} - ${student.company || 'Placement'}`}
                                        className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                                        loading="lazy"
                                    />
                                    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-emerald-900/80 to-transparent p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                        <p className="text-white text-sm font-medium">{student.company || 'Placement'}</p>
                                        {student.name && (
                                            <p className="text-white text-xs">{student.name}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Desktop View - Infinite Slider */}
                <div className="hidden md:block overflow-hidden w-full">
                    <div className="flex animate-infinite-scroll">
                        {/* First set */}
                        {placements.map((student, index) => (
                            <div
                                key={`first-${index}`}
                                className="flex-shrink-0 w-[300px] mx-4"
                            >
                                <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
                                    <div className="relative overflow-hidden h-72 w-full">
                                        <img
                                            src={student.image}
                                            alt={`${student.name || 'Graduate'} - ${student.company || 'Placement'}`}
                                            className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
                                            loading="lazy"
                                        />
                                        {/* <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-emerald-900/80 to-transparent p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                                            <p className="text-white text-sm font-medium">{student.company || 'Placement'}</p>
                                            {student.name && (
                                                <p className="text-white text-xs">{student.name}</p>
                                            )}
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* Second and third sets remain the same */}
                        {/* ... existing second and third sets code ... */}
                    </div>
                </div>
            </div>
        );
    };


    const WhyUsSection = () => {
        const features = [
            // {
            //     icon: <Zap className="w-7 h-7" />,
            //     title: "Strong Academic Foundation:",
            //     description: "We deliver high-quality education through wellstructured programs, qualified faculty, and a modern curriculum aligned with industry standards. "
            // },
            {
                icon: <Shield className="w-7 h-7" />,
                title: "Practical Application: ",
                description: "Applied sciences focus on applying scientific knowledge to solve real-world problems, making it a hands-on and engaging field."
            },
            {
                icon: <Globe className="w-7 h-7" />,
                title: "Interdisciplinary Nature: ",
                description: "Applied sciences draw from multiple disciplines, allowing you to gain a holistic view of science and develop a wide range of skills.  "
            },
            {
                icon: <LucideSearch className="w-7 h-7" />,
                title: "Career Opportunities: ",
                description: "Applied science degrees can lead to various career paths in fields like healthcare, environmental science, data science and more.  "
            },
            {
                icon: <Users className="w-7 h-7" />,
                title: "Personal Growth: ",
                description: "The field fosters critical thinking, problem-solving, and analytical skills, which are valuable in many aspects of life.   "
            },
            {
                icon: <Activity className="w-7 h-7" />,
                title: "Continuous Learning: ",
                description: "As our understanding of the world evolves, applied sciences are constantly evolving, providing opportunities for continuous learning and advancement.  "
            },
            // {
            //     icon: <Activity className="w-7 h-7" />,
            //     title: "Affordable Education: ",
            //     description: "Quality education at a reasonable cost, with scholarships available for meritorious students. "
            // },
            {
                icon: <Activity className="w-7 h-7" />,
                title: "Real-World Impact:  ",
                description: "Applied science can contribute to solving global challenges and improving people's lives, making it a rewarding field to pursue.  "
            }
        ];

        return (
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="bg-white p-8 rounded-xl shadow-lg mb-12"
            >
                <div className="flex flex-col md:flex-row gap-8">
                    <div className="w-full md:w-1/3">
                        <div className="sticky top-24">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="p-3 bg-[#0e4d38] rounded-lg text-white">
                                    <CheckCircle className="w-6 h-6" />
                                </div>
                                <h2 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">Why Join Us?</h2>
                            </div>
                            <p className="text-gray-700 mb-6">The School of Life and Applied Sciences offers students a unique opportunity to explore one of the most dynamic and essential fields of science. With a blend of innovative teaching methods and cutting-edge research, our department fosters an environment where curiosity and creativity thrive. Students benefit from projector based classrooms, personalized mentorship, and access to modern lab facilities, ensuring they receive the hands-on experience crucial for mastering complex concepts. Our school is committed to providing diverse learning opportunities, from undergraduate research projects to internships with industry leaders. Moreover, students are encouraged to participate in science clubs, workshops, and seminars, further enhancing their academic experience.  </p>
                            <div className="relative h-60 md:h-80 rounded-lg overflow-hidden">
                                <img
                                    src={Why}
                                    alt="Students collaborating"
                                    className="w-full h-full object-cover"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#0e4d38] to-transparent p-4">
                                    <p className="text-white font-semibold">Joining Maya Devi University means becoming part of a progressive academic community dedicated to shaping future leaders, professionals, and innovators. </p>
                                </div>
                            </div>
                            <div className="mt-6">
                                <Link to="https://admission.maya.edu.in/">
                                    <motion.button
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        className="w-full bg-[#0e4d38] text-white px-6 py-3 rounded-lg text-lg font-semibold flex items-center justify-center gap-2"
                                    >
                                        Apply Now
                                        <ArrowRight className="w-5 h-5" />
                                    </motion.button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-2/3">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {features.map((feature, index) => (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: index * 0.1 }}
                                    className="bg-gray-50 p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
                                >
                                    <div className="text-[#0e4d38] mb-4">
                                        <div className="p-3 bg-[#0e4d38]/10 rounded-lg inline-block">
                                            {feature.icon}
                                        </div>
                                    </div>
                                    <h3 className="text-xl font-bold mb-3 text-gray-800">{feature.title}</h3>
                                    <p className="text-gray-600">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </div>
            </motion.div>
        );
    };

    // Function to move to next testimonial
    const nextTestimonial = () => {
        setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
    };

    // Function to move to previous testimonial
    const prevTestimonial = () => {
        setActiveTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    };

    const viewCertificate = (index) => {
        setSelectedIndex(index);
        setShowCertificate(true);
    };

    const closeCertificate = () => {
        setShowCertificate(false);
    };
    return (
        <div className="font-sans">

            {/* 4. Global Opportunities Section */}
            <section className="py-16 bg-gradient-to-r from-emerald-800 to-emerald-600 text-white">
                <div className="container mx-auto px-4">
                    <div className="bg-white/10 p-10 rounded-2xl backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all duration-300 shadow-md">
                        <h2 className="text-3xl font-bold text-white mb-6">Global Opportunities</h2>
                        <ul className="space-y-6 text-white text-lg leading-relaxed">
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Postgraduate students are mentored for higher studies and research in top-ranking global institutions.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    The curriculum aligns with international academic standards, preparing students for exams like GRE, TOEFL, and IELTS for global education pathways.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Chemistry graduates can pursue global careers as Research Chemists, Analytical Chemists, Medicinal Chemists, Food Chemists, Computational Chemists, Polymer Chemists, QC Chemists, Nuclear Chemists, and more in sectors like pharma, healthcare, agriculture, and industry.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Environmental Science, Botany, Zoology, Microbiology, and Biotechnology graduates find roles in global research organizations, government agencies, and private sector industries.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="mt-2 mr-3 w-2 h-2 bg-emerald-400 rounded-full"></span>
                                <span>
                                    Zoologists can contribute to global conservation initiatives with organizations like WWF, UNEP, and CITES. International research opportunities also exist via ZSI, WWI, DRDO, UCOST, CSIR, ICAR, and other global collaborations.
                                </span>
                            </li>
                        </ul>
                    </div>

                </div>
            </section>

            {/* 5.	Program Names:  */}
            <div className="space-y-6 md:space-y-8">
                <Department
                    title="Programs"
                    icon={<Microscope className="w-5 h-5 md:w-6 md:h-6" />}
                />
            </div>

            {/* Dean Section */}
            <DeanSection />

            {/* 7.Students' Achievements / Placements:  */}
            <section className="py-20 bg-gradient-to-b from-gray-50 to-gray-100">
                <div className="container mx-auto px-4">
                    <div className="mb-14 text-center">
                        <h2 className="text-4xl font-bold mb-5 text-emerald-800 relative inline-block">
                            Student Placements
                            {/* <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-emerald-500 rounded-full"></span> */}
                        </h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Our graduates are making an impact in prestigious organizations worldwide
                        </p>
                    </div>

                    {/* Infinite Slider */}
                    <div className="overflow-hidden">
                        <InfiniteSlider placements={placements} />
                    </div>
                </div>
            </section>

            {/* <PlacementPartners /> */}
            <ScienceLogoSlider />

            <WhyUsSection />


            {/*10. Awards & Patents Section - Modernized with green theme */}




            {/* 11. Clubs Section - Modernized with green theme */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4">
                    {/* Main Section Heading */}
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-emerald-800 mb-4">CLUBS & SOCIETIES OF THE DEPARTMENT </h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Engage beyond academics with our vibrant student organizations
                        </p>
                    </div>

                    {/* Clubs Section */}
                    <div className="mb-12">
                        <h3 className="text-2xl font-bold text-emerald-700 mb-6 text-center">Clubs</h3>
                        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
                            {clubs.map((club, index) => (
                                <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                                    <div className="bg-gradient-to-r from-emerald-600 to-emerald-500 text-white p-6 flex items-center">
                                        <div className="text-3xl mr-4">{club.icon}</div>
                                        <h3 className="text-xl font-bold">{club.name}</h3>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Societies Section */}
                    <div>
                        <h3 className="text-2xl font-bold text-emerald-700 mb-6 text-center">Societies</h3>
                        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
                            {societies.map((society, index) => (
                                <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                                    <div className="bg-gradient-to-r from-emerald-600 to-emerald-500 text-white p-6 flex items-center">
                                        <div className="text-3xl mr-4">{society.icon}</div>
                                        <h3 className="text-xl font-bold">{society.name}</h3>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>


            {/*12.  StudentTestimonials */}
            <StudentTestimonials testimonials={testimonials} />

            {/* Call to Action */}
            {/* <section className="py-16 bg-gradient-to-br from-emerald-600 to-emerald-800 text-white">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-4xl font-bold mb-6">Begin Your Pharmaceutical Journey</h2>
                    <p className="text-xl mb-8 max-w-2xl mx-auto">
                        Join our prestigious School of Pharmacy and become part of the next generation of pharmaceutical innovators.
                    </p>
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <button className="bg-white text-emerald-800 px-8 py-4 rounded-full font-semibold hover:bg-emerald-50 transition-colors">
                            <Link to="https://admission.maya.edu.in/"> Apply Now </Link>
                        </button>
                        
                    </div>
                </div>
            </section> */}
        </div>
    );
};


// PDF Document Card Component
const DocumentCard = ({ document }) => (
    <motion.div
        whileHover={{ scale: 1.02 }}
        className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-100 hover:shadow-lg transition-all duration-300"
    >
        <div className="p-4">
            <div className="flex justify-between items-center mb-3">
                <div className="p-2 bg-blue-50 rounded-lg">
                    {document.icon}
                </div>
                <a href={document.path} download>
                    <motion.div
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.95 }}
                        className="p-2 bg-gray-50 hover:bg-gray-100 rounded-full"
                    >
                        <Download className="w-4 h-4 text-gray-600" />
                    </motion.div>
                </a>
            </div>
            <h3 className="font-semibold text-gray-800 mb-1 text-sm md:text-base">{document.name}</h3>
            <p className="text-gray-600 text-xs md:text-sm mb-3">{document.description}</p>
            <a
                href={document.path}
                download
                className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-[#0e4d38] hover:text-[#0a3b2a] transition-colors"
            >
                Download PDF
                <ArrowUpRight className="w-3 h-3" />
            </a>
        </div>
    </motion.div>
);

// PDF Resources Section
const ResourcesSection = ({ category }) => (
    <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-white p-4 md:p-6 rounded-xl shadow-lg"
    >
        <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6 border-b pb-4">
            <div className="p-2 md:p-3 bg-[#0e4d38] rounded-lg text-white">
                {category.icon}
            </div>
            <h4 className="text-lg md:text-xl font-semibold text-[#0e4d38]">{category.title}</h4>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {category.documents.map((doc, index) => (
                <DocumentCard key={index} document={doc} />
            ))}
        </div>
    </motion.div>
);

const Science = () => {
    return (
        <div className="min-h-screen bg-gray-50 font-poppins mt-[70px]">
            <Title canonicalPath="/programmes/ug-courses/pharmacy" />
            <Title title="School of Pharmacy at Maya Devi University, Dehradun" description=" Join the School of Pharmacy at Maya Devi University, Dehradun. Pursue a rewarding career in pharmacy with expert knowledge and practical skills in healthcare." />
            <div className="max-w-7xl mx-auto pt-16 md:pt-20 pb-8 md:pb-16 px-4 space-y-6 md:space-y-8">
                <HeroSection />
                <AboutSection />
                <Stats />
                <PharmacyDepartment />

                {/* <StudentAchievements /> */}


                {/* PDF Resources Sections */}
                {/* <div className="space-y-6 md:space-y-8">
                    {pdfResources.map((category, index) => (
                        <ResourcesSection key={index} category={category} />
                    ))}
                </div> */}

                {/* <div className="space-y-6 md:space-y-8">
                    <FeatureList
                        title="USPs"
                        icon={<Stars className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "PCI Approved Programs",
                            "Experienced Faculty with Industry Background",
                            "State-of-the-art Laboratories",
                            "Industry-Integrated Curriculum",
                            "Hands-on Training",
                            "Research Opportunities",
                            "Regular Industrial Visits",
                            "Modern Teaching Methods",
                            "Well-equipped Library",
                            "Industry Collaboration",
                            "Mentorship Program",
                            "Career Development Support"
                        ]}
                    />

                    <FeatureList
                        title="Career Options"
                        icon={<Stethoscope className="w-6 h-6 text-[#0e4d38]" />}
                        items={[
                            "Clinical Pharmacist",
                            "Hospital Pharmacist",
                            "Research Scientist",
                            "Drug Safety Associate",
                            "Quality Control Manager",
                            "Regulatory Affairs Officer",
                            "Production Manager",
                            "Medical Writer",
                            "Pharmaceutical Sales",
                            "Drug Inspector",
                            "Academic Researcher",
                            "Healthcare Consultant"
                        ]}
                    />
                </div> */}
            </div>
            <Footer />
        </div>
    );
};

export default Science;